import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <div className="pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 mb-6 bg-blue-500/10 border border-blue-500/20 px-5 py-2 rounded-full">
              <i className="ri-file-text-line text-blue-600"></i>
              <span className="text-blue-700 font-semibold text-sm tracking-wider uppercase">Legal</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Terms of <span className="bg-gradient-to-r from-red-600 to-blue-600 bg-clip-text text-transparent">Service</span>
            </h1>
            <p className="text-lg text-gray-600">Last updated: January 2024</p>
          </div>

          {/* Content */}
          <div className="prose prose-lg max-w-none">
            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border border-gray-100 mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-information-line text-blue-600"></i>
                Agreement to Terms
              </h2>
              <p className="text-gray-600 leading-relaxed mb-6">
                These Terms of Service constitute a legally binding agreement between you and Madina Associates regarding your use of our website and services. By accessing or using our services, you agree to be bound by these terms.
              </p>
              <p className="text-gray-600 leading-relaxed">
                If you do not agree with any part of these terms, you must not use our website or services. We reserve the right to modify these terms at any time, and your continued use of our services constitutes acceptance of any changes.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border border-gray-100 mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-service-line text-blue-600"></i>
                Services Provided
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Madina Associates provides the following services:
              </p>
              <ul className="space-y-3">
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-building-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span><strong>Property Dealing:</strong> Buying, selling, and leasing of residential and commercial properties</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-hammer-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span><strong>Construction Services:</strong> Design, planning, and execution of construction projects</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-landscape-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span><strong>Land Development:</strong> Site preparation and development services</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-line-chart-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span><strong>Investment Consulting:</strong> Real estate investment advice and portfolio management</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-scales-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span><strong>Legal Support:</strong> Documentation and legal assistance for property transactions</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border border-gray-100 mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-user-line text-blue-600"></i>
                User Responsibilities
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                When using our services, you agree to:
              </p>
              <ul className="space-y-3">
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-check-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span>Provide accurate and complete information</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-check-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span>Maintain the confidentiality of your account information</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-check-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span>Use our services only for lawful purposes</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-check-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span>Not interfere with or disrupt our services</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-check-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span>Comply with all applicable laws and regulations</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border border-gray-100 mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-copyright-line text-blue-600"></i>
                Intellectual Property
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                All content on our website, including text, graphics, logos, images, and software, is the property of Madina Associates and is protected by copyright, trademark, and other intellectual property laws.
              </p>
              <p className="text-gray-600 leading-relaxed">
                You may not reproduce, distribute, modify, or create derivative works from any content on our website without our express written permission.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border border-gray-100 mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-money-dollar-circle-line text-blue-600"></i>
                Payment Terms
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                For services requiring payment:
              </p>
              <ul className="space-y-3">
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span>All fees and charges will be clearly communicated before service commencement</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span>Payment terms will be specified in individual service agreements</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span>Late payments may incur additional charges as specified in your agreement</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-blue-600 mt-1 flex-shrink-0"></i>
                  <span>Refund policies will be outlined in individual service contracts</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border border-gray-100 mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-shield-cross-line text-blue-600"></i>
                Limitation of Liability
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                To the fullest extent permitted by law, Madina Associates shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our total liability for any claims arising from our services shall not exceed the amount paid by you for the specific service giving rise to the claim.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border border-gray-100 mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-file-warning-line text-blue-600"></i>
                Disclaimers
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Our services are provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee:
              </p>
              <ul className="space-y-3">
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-close-circle-line text-red-500 mt-1 flex-shrink-0"></i>
                  <span>Uninterrupted or error-free service</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-close-circle-line text-red-500 mt-1 flex-shrink-0"></i>
                  <span>Accuracy or completeness of information</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-close-circle-line text-red-500 mt-1 flex-shrink-0"></i>
                  <span>Specific results from using our services</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-close-circle-line text-red-500 mt-1 flex-shrink-0"></i>
                  <span>Security of data transmission</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border border-gray-100 mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-close-circle-line text-blue-600"></i>
                Termination
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                We reserve the right to terminate or suspend your access to our services at any time, without prior notice, for conduct that we believe:
              </p>
              <ul className="space-y-3">
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-error-warning-line text-red-500 mt-1 flex-shrink-0"></i>
                  <span>Violates these Terms of Service</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-error-warning-line text-red-500 mt-1 flex-shrink-0"></i>
                  <span>Is harmful to other users or our business</span>
                </li>
                <li className="text-gray-600 flex items-start gap-3">
                  <i className="ri-error-warning-line text-red-500 mt-1 flex-shrink-0"></i>
                  <span>Violates applicable laws or regulations</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border border-gray-100 mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-scales-3-line text-blue-600"></i>
                Governing Law
              </h2>
              <p className="text-gray-600 leading-relaxed">
                These Terms of Service shall be governed by and construed in accordance with the laws of the jurisdiction in which Madina Associates operates, without regard to its conflict of law provisions. Any disputes arising from these terms shall be resolved in the courts of that jurisdiction.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-red-50 rounded-2xl p-8 md:p-12 border-2 border-blue-100">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-mail-line text-blue-600"></i>
                Contact Information
              </h2>
              <p className="text-gray-600 leading-relaxed mb-6">
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <div className="space-y-3">
                <p className="text-gray-900 font-semibold flex items-center gap-3">
                  <i className="ri-mail-fill text-blue-600"></i>
                  info@madinaassociates.com
                </p>
                <p className="text-gray-900 font-semibold flex items-center gap-3">
                  <i className="ri-phone-fill text-blue-600"></i>
                  +1 (555) 123-4567
                </p>
                <p className="text-gray-900 font-semibold flex items-start gap-3">
                  <i className="ri-map-pin-fill text-blue-600 mt-1"></i>
                  <span>123 Business Avenue, Suite 500<br />Metropolitan City, MC 12345</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
